import Process from "screens/private/process";
export default Process;
